import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fieldActions from '../../../core/store/fields/field.actions';
import { Field } from '../../../core/store/fields/field.model';
import * as layoutActions from '../../../core/store/layout/layout.actions';
import { rootSelectors } from '../../../core/store/selectors';
import { TableTypes } from '../../../core/store/types';
import { PDropdownOption } from '../../interfaces/p-dropdown-options';

export interface MobileColumnModalData {
    allFieldOptions: PDropdownOption[];
    selectedFields: Field[];
    selectedFieldOptions: number[];
    tableType: TableTypes;
}

@Component({
    templateUrl: './mobile-column-modal.component.html',
    styleUrls: ['./mobile-column-modal.component.scss'],
    standalone: false
})
export class MobileColumnModalComponent implements OnInit {
    allFieldOptions: PDropdownOption[] = [];
    columnForm: UntypedFormGroup;
    selectedFields: Field[] = [];
    selectedFieldOptions: number[] = [];
    tableType: TableTypes;

    constructor(@Inject(MAT_DIALOG_DATA) private data: MobileColumnModalData, public dialogRef: MatDialogRef<MobileColumnModalComponent>, private fb: UntypedFormBuilder, private store: Store<rootSelectors.State>) { }

    ngOnInit() {
        this.allFieldOptions = this.data.allFieldOptions;
        this.selectedFields = this.data.selectedFields;
        this.selectedFieldOptions = this.data.selectedFieldOptions;
        this.tableType = this.data.tableType;
        this.buildForm();
    }

    buildForm() {
        const formObj = {};
        const initial = { value: this.selectedFieldOptions, disabled: false };
        const validators = [];
        validators.push(Validators.required);
        formObj['columnSelect'] = [initial, validators];
        this.columnForm = this.fb.group(formObj);
    }

    save() {
        if (!this.selectedFieldOptions.length) {
            this.selectedFieldOptions = this.selectedFields.map(f => f.id);
            return this.store.dispatch(new layoutActions.ErrorAction({
                error: new HttpErrorResponse({ error: new Error('Must select at least 1 column') })
            }));
        }

        if (this.tableType === TableTypes.TransactionTable) {
            this.store.dispatch(new fieldActions.SaveTransactionSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.DivisionTable) {
            this.store.dispatch(new fieldActions.SaveDivisionAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.EventTable) {
            this.store.dispatch(new fieldActions.SaveEventAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.FranchiseTable) {
            this.store.dispatch(new fieldActions.SaveAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.FranchiseGroupTable) {
            this.store.dispatch(new fieldActions.SaveFranchiseGroupAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.DivisionGroupTable) {
            this.store.dispatch(new fieldActions.SaveDivisionGroupAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.RequestTable) {
            this.store.dispatch(new fieldActions.SaveRequestAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.StudioGroupTable) {
            this.store.dispatch(new fieldActions.SaveStudioGroupAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.FranchiseSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveFranchiseSubGroupAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.DivisionSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveDivisionSubGroupAssetSelectedAction(this.selectedFieldOptions));
        } else if (this.tableType === TableTypes.StudioSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveStudioSubGroupAssetSelectedAction(this.selectedFieldOptions));
        }
        this.dialogRef.close();
    }
}
